/* @bend-expect quartz-no-create-browser-history */
import { createBrowserHistory } from 'history';
import { getRootUrl } from '../utils/urls';
export const history = createBrowserHistory({
  basename: getRootUrl()
});